module.exports = __webpack_public_path__ + "img/deals-active.c88dbf02.svg";